import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['line', { x1: '5', y1: '3', x2: '19', y2: '3', key: 'x74652' }],
  ['line', { x1: '3', y1: '5', x2: '3', y2: '19', key: '31ivqu' }],
  ['line', { x1: '21', y1: '5', x2: '21', y2: '19', key: '1am4cd' }],
  ['line', { x1: '9', y1: '21', x2: '10', y2: '21', key: 'sb02er' }],
  ['line', { x1: '14', y1: '21', x2: '15', y2: '21', key: '1bvb1m' }],
  ['path', { d: 'M 3 5 A2 2 0 0 1 5 3', key: 'dbypyf' }],
  ['path', { d: 'M 19 3 A2 2 0 0 1 21 5', key: 'y6haui' }],
  ['path', { d: 'M 5 21 A2 2 0 0 1 3 19', key: 'kb75wq' }],
  ['path', { d: 'M 21 19 A2 2 0 0 1 19 21', key: '1p3zbf' }],
  ['circle', { cx: '8.5', cy: '8.5', r: '1.5', key: 'cn5opk' }],
  ['line', { x1: '9.56066', y1: '9.56066', x2: '12', y2: '12', key: 'mksg6j' }],
  ['line', { x1: '17', y1: '17', x2: '14.82', y2: '14.82', key: '1lwi1d' }],
  ['circle', { cx: '8.5', cy: '15.5', r: '1.5', key: '12hfy1' }],
  ['line', { x1: '9.56066', y1: '14.43934', x2: '17', y2: '7', key: '4jyfgs' }],
];

/**
 * @component @name SquareBottomDashedScissors
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8bGluZSB4MT0iNSIgeTE9IjMiIHgyPSIxOSIgeTI9IjMiIC8+CiAgPGxpbmUgeDE9IjMiIHkxPSI1IiB4Mj0iMyIgeTI9IjE5IiAvPgogIDxsaW5lIHgxPSIyMSIgeTE9IjUiIHgyPSIyMSIgeTI9IjE5IiAvPgogIDxsaW5lIHgxPSI5IiB5MT0iMjEiIHgyPSIxMCIgeTI9IjIxIiAvPgogIDxsaW5lIHgxPSIxNCIgeTE9IjIxIiB4Mj0iMTUiIHkyPSIyMSIgLz4KICA8cGF0aCBkPSJNIDMgNSBBMiAyIDAgMCAxIDUgMyIgLz4KICA8cGF0aCBkPSJNIDE5IDMgQTIgMiAwIDAgMSAyMSA1IiAvPgogIDxwYXRoIGQ9Ik0gNSAyMSBBMiAyIDAgMCAxIDMgMTkiIC8+CiAgPHBhdGggZD0iTSAyMSAxOSBBMiAyIDAgMCAxIDE5IDIxIiAvPgogIDxjaXJjbGUgY3g9IjguNSIgY3k9IjguNSIgcj0iMS41IiAvPgogIDxsaW5lIHgxPSI5LjU2MDY2IiB5MT0iOS41NjA2NiIgeDI9IjEyIiB5Mj0iMTIiIC8+CiAgPGxpbmUgeDE9IjE3IiB5MT0iMTciIHgyPSIxNC44MiIgeTI9IjE0LjgyIiAvPgogIDxjaXJjbGUgY3g9IjguNSIgY3k9IjE1LjUiIHI9IjEuNSIgLz4KICA8bGluZSB4MT0iOS41NjA2NiIgeTE9IjE0LjQzOTM0IiB4Mj0iMTciIHkyPSI3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/square-bottom-dashed-scissors
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const SquareBottomDashedScissors = createLucideIcon('square-bottom-dashed-scissors', __iconNode);

export default SquareBottomDashedScissors;
